<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/outrightdoublematch")
          i.fas.fa-futbol
          span.ml-1 {{ $t("ui.outright_double_match") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-1
              SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="getList" size="sm" variant="info")
            div.col-md-3
              b-input-group(size="sm").mb-1
                b-input-group-text(slot="prepend")
                  div.d-flex.justify-content-center.align-items-center
                    label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                      input.switch-input(type="checkbox" v-model="$options.refreshEnabled" @change="toggleRefresh()")
                      span.switch-slider(:data-checked='on' :data-unchecked='off')
                b-input(v-model="refreshTime" type="range" min="5" max="15")
                b-input-group-text(slot="append")
                  div(style="text-transform: none;") {{ refreshTime }} m
        div.card-body
          div.row
            div.col-md-10
              b-pagination.float-left(
                size="sm"
                hide-ellipsis
                :total-rows="totalRow"
                :per-page="getPageSize"
                v-model="currentPage"
                @input="changedPage($event)").mb-1
            div.col-md-2
              b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                b-input(:value="totalRow" readonly)
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th(width=100)
                        span {{ $t('ui.id') }}
                      th(width=80)
                        span {{ $tc('ui.sports', 1) }}
                      th
                        span {{ $tc("ui.leagues", 1) }}
                      th(width=250)
                        span {{ $tc("ui.teams", 1) }}
                      th(width=80)
                        span {{ $t("ui.short.match_date") }}
                      th(width=80)
                        span {{ $t("ui.short.match_time") }}
                      th(width=70)
                        span {{ $t("ui.sbo") }}
                      th(width=70)
                        span {{ $t("ui.ibc") }}
                      th(width=70)
                        span {{ $t("ui.linked") }}
                      th(width=120)
                        span {{ $t("ui.created_on") }}
                  tbody.clusterize-content
                    tr(v-if="list.length == 0")
                      td(colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in list")
                      td
                        span {{ item.match_id }}
                      td
                        span {{ item.sport_type }}
                      td
                        span(:title="item.league_name") {{ item.league_name }}
                      td
                        span(:title="item.team_name") {{ item.team_name }}
                      td
                        span {{ getDate(item.match_date) }}
                      td
                        span {{ item.match_time }}
                      td
                        span {{ item.sbo_map }}
                      td
                        span {{ item.ibc_map }}
                      td
                        span {{ item.link_id }}
                      td
                        span {{ $moment(item.created_on).format("YYYY-MM-DD HH:mm:ss") }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    search: '',
    list: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "league_name",
    sortType: "asc",
    timerId: null,
    refreshTime: 5,
    refreshUpdate: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    }
  },
  created: function() {
    this.$options.refreshEnabled = false;
  },
  mounted: function() {
    this.getList();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getList: function() {
      let url = config.outrightDoubleMatchListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.outrightdoublematch,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.list = response.data.tbl_outright_double_match_list;
                this.totalRow = this.list.length > 0 ? this.list[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    toggleRefresh: function() {
      this.startCountDownRefresh();
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000 * 60);
      } else {
        this.refreshUpdate = "STOPPED";
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getList();
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>